import { render, staticRenderFns } from "./field_management.vue?vue&type=template&id=1360b13a&scoped=true&"
import script from "./field_management.vue?vue&type=script&lang=js&"
export * from "./field_management.vue?vue&type=script&lang=js&"
import style0 from "./field_management.vue?vue&type=style&index=0&id=1360b13a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1360b13a",
  null
  
)

export default component.exports